import React, {
	Component
} from 'react';
import {debounce} from 'lodash';
import styled, { css, keyframes } from 'styled-components';
import { Sprite } from './Sprite';


const config = window.dodConfig;

const BoxBody = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-top: ${(p) => {
		if(typeof p.top === 'number'){
			return p.top;
		}
		return config.isLandscape && !p.top ? 5 : 0;
	}}%;
`

const Message = styled.img `
	width: ${(p) => {
		if(typeof p.width === 'number'){
			return p.width;
		}
		return config.isLandscape ? p.top ? 34 : 64 : 86;
	}}%;
	margin: 0 ${(p) => {
		if(typeof p.width === 'number'){
			return (100 - p.width) / 2;
		}
		return config.isLandscape ?  p.top ? 33 : 18 : 7;
	}}%;
	/* ${p => config.isLandscape ?  p.top ? 33 : 18 : 7}%; */
	position: absolute;
	top: ${p => p.top ? 200 : 50}%; /* positions the message halfway down the "tutorial" or other banner if it exists */
	left: 0;
`

const Banner = styled.img`
	/* position: absolute; */
	margin: 0 15%;
	width: ${p => config.isLandscape ? 25 : 70}%;
	z-index: 1;

`

export class MessageBox extends Component {
	render(){
		return (
			<BoxBody>
				{this.props.banner && <Banner src="/assets/tutorial/banner_tutorial.png" />}
				<Message  src={`/assets/tutorial/${this.props.msg}.jpg`} />
				{this.props.children}
			</BoxBody>
		);
	}
}


export class MessageBoxLandscape extends Component {
	render(){
		return (
			<BoxBody top={this.props.top || true}>
				{this.props.banner && <Banner src="/assets/tutorial/banner_tutorial_blank.png" />}
				<Message  width={this.props.width} src={`/assets/tutorial/${this.props.msg}.jpg`} top/>
				{this.props.children}
			</BoxBody>
		);
	}
}

const ButtonBarInner = styled.div`
	padding: 2% 0;
	width: 100%;
	flex-basis: 0;
	display: flex;
	justify-content: space-evenly;
	& .sprite {
		height: 15.5vw;
	}
	@media (min-aspect-ratio: 9/15){
		& .sprite {
			height: 14vw;
		}
	}
`
export class ButtonBar extends Component {
	render(){
		return (
			<ButtonBarInner
				className="button-bar"
				style={this.props.style}
				rightAlign={this.props.rightAlign}
			>
				{this.props.children}
			</ButtonBarInner>
		);
	}
}

const highlight = keyframes`
	0%, 100% {
		filter: saturate(1);
		/* transform: scale(1); */
	}
	50% {
		filter: saturate(3);
		/* transform: scale(1.2); */
	}
`

const ButtonWrap = styled.div`
	cursor: pointer;
	flex-basis: auto;
	user-drag: none;
	transition-property: transform;
	transition-duration: 200ms;
	transition-timing-function: cubic-bezier(.75,-0.75,0,2);;
	transform: ${p => p.down ? 'scale(0.9)' : 'scale(1)'};
	filter: ${p => p.down ? 'brightness(1.1)' : 'brightness(1)'};
	pointer-events: auto;
	animation: ${p => p.highlight ? css`${highlight} 1.5s infinite` : 'none'};
	& img.sprite {
		 height: 15vw;
	}
	@media (min-aspect-ratio: 9/15){
		& img.sprite {
			height: 12vw;
		}
	}
`

export class Button extends Component {

	state = {
		down: false
	}

	down = () => {
		this.setState({down: true});
		// if(store.phaserReady){
		// window.manager.playAudio("poop");
		// }
	}

	up = () => {
		if(this.state.down){
			// if(store.phaserReady){
			// window.manager.playAudio("pop");
			// }
			this.setState({down: false});
			if(typeof this.props.onClick === 'function'){
				this.props.onClick();
			}
		}
	}

	reset = () => {
		this.setState({down: false});
	}

	render(){
		var button = Object.keys(this.props).find(k => ['blue_ok', 'redeem', 'purchase_cancelled', 'faq', 'rankings', 'continue', 'skip', 'ok', 'cancel', 'exit', 'resign', 'skip_gray', 'blue_dont_skip', 'watch'].indexOf(k) > -1);
		return (
			<ButtonWrap
				highlight={this.props.highlight}
				alt={button}
				down={this.state.down}
				onMouseDown={this.down}
				onMouseUp={this.up}
				onMouseOut={this.reset}
				onMouseEnter={this.reset}
				onTouchStart={this.down}
				onTouchEnd={this.up}
			>
				<Sprite
					localize
					sprite={`btn_${button}.png`}
				/>
			</ButtonWrap>
		);
	}
}


const rotate = keyframes`
	0% {
		transform: rotate(0deg);
	}

	50% {
		transform: rotate(180deg);
	}

	100% {
		transform: rotate(360deg);
	}
`;

const SpinnerBody = styled.div`
	width: ${p => config.isLandscape ? 18 : 25}%;
	position: relative;
`

const Inner = styled.img`
	width: 100%;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 2;
`
const Outer = styled.img`
	width: 100%;
	position: absolute;
	animation: ${rotate} 800ms linear infinite;
	top: 0;
	left: 0;
	z-index: 1;
`

export class Spinner extends Component{
	render(){
		return (
			<SpinnerBody>
				<Outer src="/assets/spinner_ring.png"/>
				<Inner src="/assets/spinner_icon.png"/>
			</SpinnerBody>
		)
	}
}

const Text = styled.span`
	white-space: nowrap;
	text-shadow:
		-2px -2px 0 ${p => p.stroke},
		2px -2px 0 ${p => p.stroke},
		-2px 2px 0 ${p => p.stroke},
		2px 2px 0 ${p => p.stroke};
`

export function calcTextSize(size){
	var base = 930;
	if(config.isLandscape){
		return window.innerWidth / base * size;
	} else {
		return window.innerHeight / base * size;
	}
}

export class PercenText extends Component{
	constructor(props){
		super(props);
		window.addEventListener('resize', this.onResize);

		this.state = {
			size: calcTextSize(props.size)
		};
	}

	setTextSize = debounce((size) => {
		this.setState({
			size: calcTextSize(size)
		});
	}, 250, {maxWait:250});

	onResize = () => {
		console.log('resize');
		this.setTextSize(this.props.size);
	}

	componentWillUnmount(){
		window.removeEventListener('resize', this.onResize);
	}

	render(){
		return (
			<Text stroke={this.props.stroke} style={{fontSize: this.state.size+'px'}}>{this.props.children}</Text>
		);
	}
}

PercenText.defaultProps = {
	size: 20,
	stroke: 'rgba(0,0,0,0)'
}
